module.exports = __webpack_public_path__ + "img/tree-07-a-trunk.e2114b4e.png";